import { env } from "../../../env";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../globalInspector/axiosInstance";
import CommonToast from "../../../components/_utils/CommonToast";
import ICONS from "../../../assets/Icons";
import { toast } from "react-toastify";

const baseUrl = env.REACT_APP_BASE_URL;


export const getAllfieldForceTxn = createAsyncThunk(
  "getAllfieldForceTxn",
  async (values = {}, { rejectWithValue }) => {
    try {
      const {
        page_no,
        page_item_count,
        txn_id,
        field_force_account_id,
        owner_account_id,
        request_amount,
        amount,
        category,
        lifecycle_status,
        start_date,
        end_date,
        entity_id,
        additional_data,
        category_name,
        category_value,
        category_label,
        category_id,
        labels,
        payment_method,
        distribution_lifecycle_status,
      } = values;

      const response = await axiosInstance.get(
        `${baseUrl}/transactions/field_force`,
        {
          headers: {
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            page_no,
            page_size: page_item_count,
            txn_id,
            field_force_account_id,
            owner_account_id,
            request_amount,
            amount,
            category,
            category_id,
            lifecycle_status,
            start_date,
            end_date,
            entity_id,
            additional_data,
            category_name,
            category_value,
            category_label,
            labels,
            payment_method,
            distribution_lifecycle_status,
          },
        },
      );

      return response.data;
    } catch (error) {
      CommonToast({
        text: error?.response?.data?.error,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(error?.response?.data);
    }
  },
);

export const fieldForceTxnActionable = createAsyncThunk(
  "fieldForceTxnActionable",
  async (values = {}, { rejectWithValue }) => {
    const { page_no, page_size, category_id, entityId, labels } =
      values;

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/transactions/field_force/actionable`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            page_no: page_no,
            page_size: page_size,
            entity_id: entityId,
            category_id: category_id,
            labels: labels,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  },
);

export const addFieldForceTxnLabel = createAsyncThunk(
  "addFieldForceTxnLabel",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transactions/field_force/add_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      const existingLabels = JSON?.parse(
        sessionStorage?.getItem("AvailableLabelsTxnFF") || [],
      );

      const updatedLabels = Array?.from(
        new Set([...existingLabels, ...labels]),
      );

      const payload = JSON?.stringify(updatedLabels);
      sessionStorage?.setItem("AvailableLabelsTxnFF", payload);
      return response?.data;
    } catch (error) {
      toast.dismiss();
      const errorMessage =
        error?.response?.data?.ids.unsuccessful_ids[0].errors ||
        error?.response?.data?.errors?.base?.[0] ||
        error?.response?.data?.error ||
        error?.message ||
        "Something went wrong";
      
      toast.dismiss()

      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      return rejectWithValue(errorMessage);
    }
  },
);

export const removeFieldForceTxnLabel = createAsyncThunk(
  "removeFieldForceTxnLabel",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/transactions/field_force/remove_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response?.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.ids.unsuccessful_ids[0].errors ||
        error?.response?.data?.errors?.base?.[0] ||
        error?.response?.data?.error ||
        error?.message ||
        "Something went wrong";

      toast.dismiss()
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      return rejectWithValue(errorMessage);
    }
  },
);

export const getSpecificfieldForceTxn = createAsyncThunk(
  "getSpecificfieldForceTxn",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/transactions/field_force/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("error", error);
      throw error;
    }
  },
);

export const fieldForceTxnRequest = createAsyncThunk(
  "fieldForceTxnRequest",
  async (values, { rejectWithValue }) => {
    const {
      expense_type,
      amount,
      field_force_account_id,
      uploaded_file_data,
      category,
      category_id,
      additional_data,
      request_date,
      labels,
      description,
      payment_method,
      comment,
    } = values;

    const requestBody = {
      amount: amount,
      field_force_account_id: field_force_account_id,
      ...(category_id !== undefined ? { category_id } : { category }),
      additional_data: {
        data: additional_data,
      },
      expense_type: expense_type,
      uploaded_file_data: uploaded_file_data,
      description: description,
      labels: labels,
      payment_method: payment_method,
      comment,
      request_date,
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": sessionStorage.getItem("q2p_token"),
      },
    };

    try {
      const response = await axiosInstance.post(
        `${baseUrl}/requests/field_force`,
        requestBody,
        config,
      );
      return response.data;
    } catch (error) {
      sessionStorage.setItem(
        "fieldForceTxnRequestError",
        JSON.stringify(error?.response?.data?.errors),
      );
      return rejectWithValue(error?.response?.data?.errors);
    }
  },
);

export const fieldForceTxnRequestApproval = createAsyncThunk(
  "fieldForceTxnRequestApproval",
  async (values, { rejectWithValue }) => {
    const {
      request_id,
      amount,
      owner_account_id,
      comments,category_id,
      payment_method,
      labels,
    } = values;

    const requestBody = {
      field_force_requests: [
        {
          request_id,
          approved_amount: amount,
          owner_account_id,
          comments,
          category_id,
          payment_method,
          labels,
        },
      ],
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": sessionStorage.getItem("q2p_token"),
      },
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/requests/field_force/approve`,
        requestBody,
        config,
      );
      return response.data;
    } catch (error) {
      sessionStorage.setItem(
        "fieldForceTxnRequestError",
        JSON.stringify(error?.response?.data?.errors),
      );
      return rejectWithValue(error?.response?.data?.errors);
    }
  },
);

export const fieldForceTxnRequestSuccessDetail = createAsyncThunk(
  "fieldForceTxnRequestSuccessDetail",
  async (id, { rejectWithValue }) => {
    try {
      if (!id) {
        throw new Error("Invalid field force id");
      }
      const response = await axiosInstance.get(
        `${baseUrl}/requests/field_force/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const FieldForceRequestTxnMultiWaitingApproval = createAsyncThunk(
  "FieldForceRequestTxnMultiWaitingApproval",
  async (values, { rejectWithValue }) => {
    const field_force_requests = values?.field_force_requests ?? [];
    const requestBody = { field_force_requests };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/requests/field_force/approve`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      const errorData = error?.response?.data ?? {
        errors: { base: [error?.message || "Request failed"] },
      };

      sessionStorage.setItem(
        "fieldForceTxnRequestError",
        JSON.stringify(errorData?.errors ?? {}),
      );

      return rejectWithValue(errorData);
    }
  },
);

export const FieldForceRequestMultiTxnDeniedApproval = createAsyncThunk(
  "FieldForceRequestMultiTxnDeniedApproval",
  async ({ request_ids, rejection_reason }, { rejectWithValue }) => {
    const requestBody = {
      request_ids,
      rejection_reason,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/requests/field_force/reject`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      const errorData = error?.response?.data ?? {
        errors: { base: [error?.message || "Reject failed"] },
      };

      sessionStorage.setItem(
        "fieldforceTxnRejectError",
        JSON.stringify(errorData?.errors ?? {}),
      );

      return rejectWithValue(errorData);
    }
  },
);

export const fieldForceTxnWaitingApproval = createAsyncThunk(
  "fieldForceTxnWaitingApproval",
  async (id, { rejectWithValue }) => {
    try {
      const data = {
        txn_id: [id],
      };

      const response = await axiosInstance.put(
        `${baseUrl}/transactions/field_force/approve`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      if (response.status === 404) {
        return rejectWithValue(undefined);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || null);
    }
  },
);

export const fieldForceTxnDeniedApproval = createAsyncThunk(
  "fieldForceTxnDeniedApproval",
  async ({ id, AccountIdData }, { rejectWithValue }) => {
    try {
      let data = {
        txn_id: null,
        reason: AccountIdData,
      };

      if (Array.isArray(id)) {
        data.txn_id = id;
      } else {
        data.txn_id = [id];
      }

      const response = await axiosInstance.put(
        `${baseUrl}/transactions/field_force/reject`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      if (response.status === 404) {
        return rejectWithValue(undefined);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || null);
    }
  },
);

export const FieldForceMultiTxnDeniedApproval = createAsyncThunk(
  "FieldForceMultiTxnDeniedApproval",
  async ({ id, AccountIdData }, { rejectWithValue }) => {
    try {
      let data = {
        txn_id: null,
        reason: AccountIdData,
      };

      data.txn_id = id;
      data.reason = AccountIdData;

      const response = await axiosInstance.put(
        `${baseUrl}/transactions/field_force/reject`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || null);
    }
  },
);

export const FieldForceTxnMultiWaitingApproval = createAsyncThunk(
  "FieldForceTxnMultiWaitingApproval",
  async (id, { rejectWithValue }) => {
    try {
      const data = {
        txn_id: id,
      };

      const response = await axiosInstance.put(
        `${baseUrl}/transactions/field_force/approve`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const FieldForceTxnWaitingApproval = createAsyncThunk(
  "FieldForceTxnWaitingApproval",
  async (id, { rejectWithValue }) => {
    try {
      const data = {
        txn_id: [id],
      };

      const response = await axiosInstance.put(
        `${baseUrl}/transactions/field_force/approve`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      if (response.status === 404) {
        return rejectWithValue(undefined);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || null);
    }
  },
);

const fieldForceTransaction = createSlice({
  name: "fieldForceTransaction",
  initialState: {
    storedPage: 1,
    toggleFFTxn: false,
    isApprovalStatusSelected: false,

    fieldForceTxnViewAllData: null,
    fieldForceTxnViewAllLoading: false,
    fieldForceTxnViewAllError: false,

    fieldForceTxnActionableData: null,
    fieldForceTxnActionableLoading: false,
    fieldForceTxnActionableError: null,

    fieldForceTxnAddLabelsData: null,
    fieldForceAddLabelsLoading: false,
    fieldForceAddLabelsError: null,

    fieldForceTxnRemoveLabelsData: null,
    fieldForceTxnRemoveLabelsLoading: false,
    fieldForceTxnRemoveLabelsError: null,

    fieldForceTxnRequestData: null,
    fieldForceTxnRequestLoading: null,
    fieldForceTxnRequestError: null,

    fieldForceTxnRequestApprovalData: null,
    fieldForceTxnRequestApprovalLoading: null,
    fieldForceTxnRequestApprovalError: null,

    fieldForceTxnSuccessRequestData: null,
    fieldForceTxnSuccessRequestDataError: null,
    fieldForceTxnSuccessRequestLoading: null,
    fieldForceTxnSuccessRequestError: null,

    FieldForceRequestMultiTxnWaitingApprovalLoading: false,
    FieldForceRequestMultiTxnWaitingApprovalData: null,
    FieldForceRequestMultiTxnWaitingApprovalError: null,

    FieldForceRequestMultiTxnDeniedApprovalLoading: false,
    FieldForceRequestMultiTxnDeniedApprovalData: null,
    FieldForceRequestMultiTxnDeniedApprovalError: null,

    FieldForceMultiTxnDeniedApprovalData: null,
    FieldForceMultiTxnDeniedApprovalLoading: null,
    FieldForceMultiTxnDeniedApprovalError: null,

    FieldForceTxnWaitingApprovalData: null,
    FieldForceTxnWaitingApprovalLoading: null,
    FieldForceTxnWaitingApprovalError: null,

    FieldForceMultiTxnWaitingApprovalData: null,
    FieldForceMultiTxnDashBoardLoading: null,
    FieldForceMultiMultiTxnWaitingApprovalError: null,

    fieldForceTxnDetailLoading: null,
    fieldForceTxnDetailData: null,
    fieldForceTxnDetailError: null,

    fieldForceTxnWaitingApprovalData: null,
    fieldForceTxnWaitingApprovalLoading: null,
    fieldForceTxnWaitingApprovalError: null,

    fieldForceTxnDeniedApprovalData: null,
    fieldForceTxnDeniedApprovalLoading: null,
    fieldForceTxnDeniedApprovalError: null,

    totalCount: 0,
    summary: {},
    availableLabels: [],
  },
  reducers: {
    setToggleFFTxn(state, action) {
      state.toggleFFTxn = action.payload;
    },
    resetFFToggle(state) {
      state.toggleFFTxn = false;
    },
    setStoredPage(state, action) {
      state.storedPage = action.payload;
    },
    resetPage(state) {
      state.storedPage = 1;
    },
    setDetailDataToRejectData(state) {
      state.fieldForceTxnDetailData = state.fieldForceTxnDeniedApprovalData;
    },
    setDetailDataToApprovalData(state) {
      state.fieldForceTxnDetailData = state.fieldForceTxnRequestApprovalData;
    },
    setIsApprovalStatusSelected(state, action) {
      state.isApprovalStatusSelected = action.payload;
    },
    setAvailableLabels(state, action) {
      state.availableLabels = action.payload;
    },
    FieldForceMultiTxnErrors: (state) => {
      state.FieldForceMultiTxnWaitingApprovalData = null;
      state.FieldForceMultiTxnWaitingApprovalError = null;
      state.FieldForceMultiTxnDeniedApprovalData = null;

      state.FieldForceMultiTxnDeniedApprovalError = null;
      state.FieldForceMultiTxnDeniedApprovalLoading = false;
      state.FieldForceMultiTxnDashBoardLoading = false;
    },
    FieldForceRequestMultiTxnErrors: (state) => {
      state.FieldForceRequestMultiTxnWaitingApprovalLoading = null;
      state.FieldForceRequestMultiTxnWaitingApprovalError = null;
      state.FieldForceRequestMultiTxnWaitingApprovalData = null;

      state.FieldForceRequestMultiTxnDeniedApprovalLoading = null;
      state.FieldForceRequestMultiTxnDeniedApprovalData = null;
      state.FieldForceRequestMultiTxnDeniedApprovalError = null;
    },

    resetFieldForceMultiApprovalError: (state) => {
      state.FieldForceMultiMultiTxnWaitingApprovalError = null;
    },
    resetFieldForceMultiDeniedApprovalLoading: (state) => {
      state.FieldForceMultiTxnDeniedApprovalLoading = false;
    },
    resetFieldForceMultiDeniedApprovalData: (state) => {
      state.FieldForceMultiTxnDeniedApprovalError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllfieldForceTxn.pending, (state) => {
        state.fieldForceTxnViewAllLoading = true;
        state.fieldForceTxnViewAllError = false;
      })
      .addCase(getAllfieldForceTxn.fulfilled, (state, action) => {
        const payload = action.payload;

        state.fieldForceTxnViewAllLoading = false;
        state.fieldForceTxnViewAllData = payload;
        state.totalCount = payload?.total_count || 0;
        state.summary = payload?.summary || {};
        state.availableLabels = payload?.summary?.available_labels || [];

        sessionStorage.setItem(
          "AvailableLabelsTxnFF",
          JSON.stringify(state.availableLabels),
        );
      })
      .addCase(getAllfieldForceTxn.rejected, (state) => {
        state.fieldForceTxnViewAllLoading = false;
        state.fieldForceTxnViewAllError = true;
        state.fieldForceTxnViewAllData = null;
        state.totalCount = 0;
        state.summary = {};
        state.availableLabels = [];
      })

      .addCase(fieldForceTxnActionable.pending, (state) => {
        state.fieldForceTxnActionableLoading = true;
        state.fieldForceTxnActionableError = null;
      })

      .addCase(fieldForceTxnActionable.fulfilled, (state, action) => {
        const payload = action.payload;

        state.fieldForceTxnActionableLoading = false;
        state.fieldForceTxnViewAllData = payload;

        state.totalCount = payload?.total_count || 0;
        state.summary = payload?.summary || {};
        state.availableLabels = payload?.summary?.available_labels || [];
      })

      .addCase(fieldForceTxnActionable.rejected, (state, action) => {
        state.fieldForceTxnActionableLoading = false;
        state.fieldForceTxnActionableError =
          action.payload?.error || action.payload?.message;

        state.fieldForceTxnViewAllData = null;
        state.totalCount = 0;
        state.summary = {};
        state.availableLabels = [];
        CommonToast({
          text: state.fieldForceTxnActionableError,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      });

    builder.addCase(addFieldForceTxnLabel.fulfilled, (state, action) => {
      state.fieldForceTxnAddLabelsData = false;
      state.fieldForceTxnAddLabelsData = action.payload;
    });
    builder.addCase(addFieldForceTxnLabel.rejected, (state, action) => {
      state.fieldForceAddLabelsError = true;
      state.fieldForceTxnAddLabelsData = null;
      state.fieldForceTxnAddLabelsData = false;
    });
    builder.addCase(addFieldForceTxnLabel.pending, (state, action) => {
      state.fieldForceTxnAddLabelsData = true;
    });

    builder.addCase(removeFieldForceTxnLabel.fulfilled, (state, action) => {
      state.fieldForceTxnRemoveLabelsLoading = false;
      state.fieldForceTxnRemoveLabelsData = action.payload;
    });
    builder.addCase(removeFieldForceTxnLabel.rejected, (state, action) => {
      state.fieldForceTxnRemoveLabelsError = true;
      state.fieldForceTxnRemoveLabelsData = null;
      state.fieldForceTxnRemoveLabelsLoading = false;
    });
    builder.addCase(removeFieldForceTxnLabel.pending, (state, action) => {
      state.fieldForceTxnRemoveLabelsLoading = true;
    });

    builder.addCase(fieldForceTxnRequest.pending, (state, action) => {
      state.fieldForceTxnRequestLoading = true;
    });
    builder.addCase(fieldForceTxnRequest.fulfilled, (state, action) => {
      state.fieldForceTxnRequestLoading = false;
      state.fieldForceTxnRequestData = action.payload;
      state.fieldForceTxnRequestError = null;
    });
    builder.addCase(fieldForceTxnRequest.rejected, (state, action) => {
      state.fieldForceTxnRequestLoading = false;
      state.fieldForceTxnRequestError = action.payload;
      state.fieldForceTxnRequestData = null;
    });

    builder.addCase(fieldForceTxnRequestApproval.pending, (state, action) => {
      state.fieldForceTxnRequestApprovalLoading = true;
    });
    builder.addCase(fieldForceTxnRequestApproval.fulfilled, (state, action) => {
      state.fieldForceTxnRequestApprovalLoading = false;
      state.fieldForceTxnRequestApprovalData = action.payload;
      state.fieldForceTxnRequestApprovalError = null;
    });
    builder.addCase(fieldForceTxnRequestApproval.rejected, (state, action) => {
      state.fieldForceTxnRequestApprovalLoading = false;
      state.fieldForceTxnRequestApprovalError = action.payload;
      state.fieldForceTxnRequestApprovalData = null;
    });

    builder.addCase(
      FieldForceRequestTxnMultiWaitingApproval.pending,
      (state) => {
        state.FieldForceRequestMultiTxnWaitingApprovalLoading = true;
      },
    );

    builder.addCase(
      FieldForceRequestTxnMultiWaitingApproval.fulfilled,
      (state, action) => {
        state.FieldForceRequestMultiTxnWaitingApprovalLoading = false;
        state.FieldForceRequestMultiTxnWaitingApprovalData = action.payload;
      },
    );

    builder.addCase(
      FieldForceRequestTxnMultiWaitingApproval.rejected,
      (state, action) => {
        state.FieldForceRequestMultiTxnWaitingApprovalLoading = false;
        state.FieldForceRequestMultiTxnWaitingApprovalError = action.payload;
      },
    );

    builder.addCase(
      FieldForceRequestMultiTxnDeniedApproval.pending,
      (state) => {
        state.FieldForceRequestMultiTxnDeniedApprovalLoading = true;
      },
    );

    builder.addCase(
      FieldForceRequestMultiTxnDeniedApproval.fulfilled,
      (state, action) => {
        state.FieldForceRequestMultiTxnDeniedApprovalLoading = false;
        state.FieldForceRequestMultiTxnDeniedApprovalData = action.payload;
      },
    );

    builder.addCase(
      FieldForceRequestMultiTxnDeniedApproval.rejected,
      (state, action) => {
        state.FieldForceRequestMultiTxnDeniedApprovalLoading = false;
        state.FieldForceRequestMultiTxnDeniedApprovalError = action.payload;
      },
    );

    builder.addCase(
      FieldForceMultiTxnDeniedApproval.pending,
      (state, action) => {
        state.FieldForceMultiTxnDeniedApprovalLoading = true;
      },
    );
    builder.addCase(
      FieldForceMultiTxnDeniedApproval.fulfilled,
      (state, action) => {
        state.FieldForceMultiTxnDeniedApprovalLoading = false;
        state.FieldForceMultiTxnDeniedApprovalData = action.payload;
      },
    );
    builder.addCase(
      FieldForceMultiTxnDeniedApproval.rejected,
      (state, action) => {
        if (action.payload?.errors?.base) {
          sessionStorage.setItem(
            "FieldforceDataError",
            JSON.stringify(action.payload.errors.base),
          );
        } else if (action.payload) {
          sessionStorage.setItem(
            "FieldforceDataError",
            JSON.stringify(action.payload),
          );
        }
        state.FieldForceMultiTxnDeniedApprovalError = action?.payload;
        state.FieldForceMultiTxnDeniedApprovalData = null;
        state.FieldForceMultiTxnDeniedApprovalLoading = false;
      },
    );

    builder.addCase(FieldForceTxnWaitingApproval.pending, (state, action) => {
      state.FieldForceTxnWaitingApprovalLoading = true;
    });

    builder.addCase(FieldForceTxnWaitingApproval.fulfilled, (state, action) => {
      state.ReimbursementTxnDashBoardLoading = false;
      state.FieldForceTxnWaitingApprovalData = action.payload;
    });

    builder.addCase(FieldForceTxnWaitingApproval.rejected, (state, action) => {
      state.FieldForceTxnWaitingApprovalError = true;
      state.FieldForceTxnWaitingApprovalData = null;
    });

    builder.addCase(
      FieldForceTxnMultiWaitingApproval.pending,
      (state, action) => {
        state.FieldForceMultiTxnDashBoardLoading = true;
      },
    );

    builder.addCase(
      FieldForceTxnMultiWaitingApproval.fulfilled,
      (state, action) => {
        state.FieldForceMultiTxnDashBoardLoading = false;
        state.FieldForceMultiTxnWaitingApprovalData = action.payload;
      },
    );
    builder.addCase(
      FieldForceTxnMultiWaitingApproval.rejected,
      (state, action) => {
        if (action.payload.response.data.errors.base) {
          sessionStorage.setItem(
            "FieldforceDataError",
            JSON.stringify(action.payload.response.data.errors.base),
          );
        }

        state.FieldForceMultiMultiTxnWaitingApprovalError = action?.payload;
        state.FieldForceMultiTxnWaitingApprovalData = null;
        state.FieldForceMultiTxnDashBoardLoading = false;
      },
    );

    builder
      .addCase(fieldForceTxnRequestSuccessDetail.pending, (state) => {
        state.fieldForceTxnSuccessRequestLoading = true;
        state.fieldForceTxnSuccessRequestDataError = null;
      })
      .addCase(fieldForceTxnRequestSuccessDetail.fulfilled, (state, action) => {
        state.fieldForceTxnSuccessRequestLoading = false;
        state.fieldForceTxnSuccessRequestData = action.payload;
        state.fieldForceTxnSuccessRequestDataError = null;
      })
      .addCase(fieldForceTxnRequestSuccessDetail.rejected, (state, action) => {
        state.fieldForceTxnSuccessRequestLoading = false;
        state.fieldForceTxnSuccessRequestData = null;
        state.fieldForceTxnSuccessRequestDataError = action.payload;
      });

    builder.addCase(getSpecificfieldForceTxn.pending, (state, action) => {
      state.fieldForceTxnDetailLoading = true;
    });
    builder.addCase(getSpecificfieldForceTxn.fulfilled, (state, action) => {
      state.fieldForceTxnDetailLoading = false;
      state.fieldForceTxnDetailData = action.payload;
    });
    builder.addCase(getSpecificfieldForceTxn.rejected, (state, action) => {
      state.fieldForceTxnDetailError = true;
    });

    builder.addCase(fieldForceTxnWaitingApproval.pending, (state, action) => {
      state.fieldForceTxnWaitingApprovalLoading = true;
    });
    builder.addCase(fieldForceTxnWaitingApproval.fulfilled, (state, action) => {
      state.fieldForceTxnDashBoardLoading = false;
      state.fieldForceTxnWaitingApprovalData = action.payload;
    });
    builder.addCase(fieldForceTxnWaitingApproval.rejected, (state, action) => {
      state.fieldForceTxnWaitingApprovalError = true;
      state.fieldForceTxnWaitingApprovalData = null;
    });

    builder.addCase(fieldForceTxnDeniedApproval.pending, (state, action) => {
      state.fieldForceTxnDeniedApprovalLoading = true;
    });
    builder.addCase(fieldForceTxnDeniedApproval.fulfilled, (state, action) => {
      state.fieldForceTxnDeniedApprovalLoading = false;
      state.fieldForceTxnDeniedApprovalData = action.payload;
    });
    builder.addCase(fieldForceTxnDeniedApproval.rejected, (state, action) => {
      state.fieldForceTxnDeniedApprovalError = true;
      state.fieldForceTxnDeniedApprovalData = null;
      state.fieldForceTxnDeniedApprovalLoading = false;
    });
  },
});

export const {
  resetFFToggle,
  setStoredPage,
  setToggleFFTxn,
  resetPage,
  setAvailableLabels,
  setIsApprovalStatusSelected,
  setDetailDataToRejectData,
  setDetailDataToApprovalData,
  FieldForceRequestMultiTxnErrors,
  FieldForceMultiTxnErrors,
  resetFieldForceMultiApprovalError,
  resetFieldForceMultiDeniedApprovalLoading,
  resetFieldForceMultiDeniedApprovalData,
} = fieldForceTransaction.actions;

export default fieldForceTransaction.reducer;
